import { mutateApi } from "../../utils/api/ApiMethods"

export const queryEmailExists = (email) => {
  return mutateApi({
    url: `/validate/email`,
    method: "POST",
    data: { email },
  })
}
